// @flow
import searchResultBuilder from './searchResult'
import prebookSearchTripBuilder from './prebookSearchTrip'

// Types
import type { PrebookSearchResponse } from '../../../api_types'
import type { SearchResult } from '../../../models/search'

export default function prebookSearchResultBuilder(
  response: PrebookSearchResponse
): SearchResult {
  const tripsList = response.results.map((result) =>
    prebookSearchTripBuilder(result, response)
  )

  return {
    ...searchResultBuilder(tripsList),
    alerts: [],
    searchId: response.search_id,
    createdAt: response.created_at,
    expiresAt: response.expires_at,
    expiresIn: response.expires_in,
  }
}
